import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-streamline-export",
  "use": "app-icon-streamline-export-usage",
  "viewBox": "0 0 18.173 15.645",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18.173 15.645\" id=\"app-icon-streamline-export\"><g fill=\"#6C92FA\" fill-rule=\"evenodd\"><path d=\"M8.099 7.086V0h1.936v7.086H14l-4.88 4.179L4 7.086z\" /><path d=\"M0 9h2.027v4.474H15.99V9h2.182v6.645H0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol